import { ApiService } from "@/api";

/**
 * 获取某个问题分组下的所有问题
 * @param {string} questionGroupId 问题分组的 id
 * @returns
 */
export const getQuestionByGroupId = (questionGroupId: string) => {
  return ApiService.baseAction(`question/list/${questionGroupId}`, {}, "GET");
};
